import { TranslationId } from '../../transloco';
import { NotificationOptions } from './notification-options';
import { NotificationType } from './notification-type';

export interface Notification {
  id: symbol;
  notificationType: NotificationType;
  message: TranslationId;
  options: NotificationOptions;
}
